import * as React from 'react';
import {QuickLinks} from "../react/quick-links.jsx";
import {ContactOptions} from "../react/contact-options.jsx";
import {
    EgenciaProvider,
    UitkHeading,
    UitkIcon,
    UitkIconSize,
    UitkLayoutFlex,
    UitkLink,
    UitkSpacing
} from "@egencia/uitk-react";
import * as ReactDOM from "react-dom";
import {ArticleError} from "../react/article-error";
import {ChatButton} from "../react/chat-button";
import {ArticleDetailsSingleArticle} from "../react/article-details-single-article";

EG.HelpCenter.Presenters.FullPageSingleArticle = function () {
    'use strict';
    const article = EG.bootstrapped.content;
    const $delegate = $('body');
    let contentIdOmnitureData;

    const headerContainer = ReactDOM.createRoot(document.getElementById("header-container"));
    const viewAllContainer = ReactDOM.createRoot(document.getElementById("view-all-container"));
    const articleDetails = ReactDOM.createRoot(document.getElementById("article-details"));
    const articleErrorContainer = ReactDOM.createRoot(document.getElementById("article-error"));
    const options = ReactDOM.createRoot(document.getElementById("options"));
    const pageTitle = uitk.i18n.msg('help_center_title');

    const tnePrestaCode = EG.bootstrapped.tnePrestaCode;

    // Set the header container and redirect container
    headerContainer.render(
        <EgenciaProvider>
            <UitkSpacing margin={{blockend: "four"}}>
                <UitkHeading tag={"h1"} size={4}>{pageTitle}</UitkHeading>
            </UitkSpacing>
        </EgenciaProvider>
    );
    
    viewAllContainer.render(
        <EgenciaProvider>
            <UitkSpacing margin={{blockend: "four"}}>
                <UitkLink>
                    <a href="/help-center">
                        <UitkIcon name={"arrow_back"} size={UitkIconSize.SMALL}/>
                        {uitk.i18n.msg('help-center_view_all')}
                    </a>
                </UitkLink>
            </UitkSpacing>
        </EgenciaProvider>
    );
    

    if (EG.bootstrapped.articleError) {
        articleErrorContainer.render(<EgenciaProvider> <ArticleError/> </EgenciaProvider>);
        contentIdOmnitureData = 'HelpCenter.SingleArticle.Displayed.Article.Not.Available';
    } else {
        contentIdOmnitureData = 'HelpCenter.SingleArticle.Displayed.' + article.defaultTitleForEmail.replace(/\?/g, '').split(' ').join('.');
    }

    options.render(
        <EgenciaProvider>
            <UitkLayoutFlex direction={"column"} space={"four"}>
                {!tnePrestaCode &&
                    <QuickLinks/>
                }
                <ContactOptions/>
                <ChatButton/>
            </UitkLayoutFlex>
        </EgenciaProvider>
    );

    articleDetails.render(
        <ArticleDetailsSingleArticle article={article}/>
    );
    
    uitk.analytics.set('prop18', contentIdOmnitureData);
    uitk.analytics.set('eVar26', contentIdOmnitureData);
    uitk.analytics.track('o', {
        linkName: 'Single Article Viewed',
        linkTrackVars: ',prop18,eVar26',
    });

    uitk.analytics.set('pageName', EG.pageName);
    uitk.analytics.send();

    $delegate.on('click', '.contact-us-link', (e) => {
        e.preventDefault();
        omnitureLog.logClickEvent(`${EG.pageName}.ContactUs.Clicked`);
        uitk.helpPanel.panelOpen(`/help-center/panel/contact-options${EG.user ? '' : '/anonymous'}?override_back=true`);
    });
};